import ReactHtmlParser from "html-react-parser";

export const parseHtmlWithNonce = (htmlString) => {
  if (!htmlString) return null;

  let converted = htmlString.replace(
    /class="([^"]*)"/g,
    (match, classNames) => {
      // Split the class names by space, add '-api' suffix to each, and join back
      const updatedClassNames = classNames
        .split(" ")
        .map((className) => {
          // Check if it's an MUI class and add '-api' suffix
          if (className.startsWith("Mui")) {
            return className + "-api";
          }
          return className;
        })
        .join(" ");
      return `class="${updatedClassNames}"`;
    }
  );
  return ReactHtmlParser(converted);
};
